/** @jsx jsx */

import { ComponentProps } from 'react';

import { css, jsx } from '@emotion/core';

import { MethodType } from 'app/developer-v3/hooks/useQueryInsightsIntegrationTriggersActionsDaily';
import MultiSelectDropdown from 'app/developer-v3/components/MultiSelectDropdown';

const Styles = {
  root: css`
    display: flex;
    flex-direction: column;
    width: 275px;

    & > label {
      display: inline-block;
      margin-bottom: 8px;
      font-weight: 600;
    }
  `,
};

type MultiSelectItems = ComponentProps<typeof MultiSelectDropdown>['items'];

type Props = {
  items: MultiSelectItems;
  type: MethodType;
  label: 'Trigger' | 'Action';
  onChange: (selectedItems: MultiSelectItems) => void;
  selectedItems: MultiSelectItems;
};

export default function TriggersActionsDropdown({
  items,
  type,
  label,
  onChange,
  selectedItems,
}: Props) {
  return (
    <div css={Styles.root}>
      <label>{label}</label>
      <MultiSelectDropdown
        emptyDropdownMessage={`No ${type} available`}
        items={items}
        itemsType={type}
        onChange={onChange}
        placeholder="Show all"
        selectedItems={selectedItems}
      />
    </div>
  );
}
